<template>
  <div class='offline-timer-scramble'>
    <h2 style='display: inline-block'> {{ $store.state.scramble }} </h2>
    <v-btn text @click='generateScramble'> next </v-btn>
    <!-- TODO: disable generateScramble button when owner hasn't yet solved the cube. Also disable if you're not the owner (but leave it visible) -->
  </div>
</template>

<script>
let scrambleGenerate = require('scramble-generator').default

export default {
  name: 'offline-timer-scramble',
  data () {
    return {
      id: 0
    }
  },
  methods: {
    generateScramble () {
      this.$emit('new-scramble', { scrambleId: this.id.toString(), scramble: scrambleGenerate() })
      this.id++
    }
  }
}
</script>
